/**
 * Workflow GraphQL fragments for field reuse.
 */
import { gql } from '@apollo/client';

export const WORKFLOW_FIELDS_FRAGMENT = gql`
  fragment WorkflowDetailFields on Workflow {
    # Identity (4 fields - tenantId is graphql(skip))
    id
    name
    version
    description

    # State Machine Structure (5 registries)
    initialState
    states {
      name
      stateType
      entryActions
      exitActions
      timeoutSeconds
    }
    transitions {
      fromState
      toState
      event
      guards
      actions
    }
    guards {
      name
      expression {
        expression
        guardType
      }
    }
    actions {
      name
      definition {
        actionType
        configuration
      }
    }

    # Execution Configuration (3 fields)
    timeoutSeconds
    retryPolicy {
      maxAttempts
      backoffSeconds
      backoffMultiplier
    }
    executionStrategy

    # Lifecycle (1 field)
    active

    # Regulatory & Compliance (10 fields)
    complianceFrameworks
    criticality
    regulations {
      id
      name
      framework
      requirement
      verificationMethod
    }
    authorityId
    complianceLevel
    auditRequirements
    jurisdictionalScope
    effectiveDate
    expirationDate
    riskClassification

    # Metadata (2 fields)
    metadata
    auditInfo {
      createdBy
      createdAt
      updatedBy
      updatedAt
      version
    }

    # Formula Tracking (8 fields)
    targetFormulas
    formulaCompletionRates {
      formulaName
      value
    }
    formulaAvgDurations {
      formulaName
      durationSeconds
    }
    recommendedExecutionStrategies {
      formulaName
      strategy
    }
    formulaStateCounts {
      formulaName
      stateCount
    }
    lastInstantiatedAt
    instantiationCount
    formulaErrorRates {
      formulaName
      value
    }

    # Append-Only Architecture (4 fields)
    parentVersionId
    originalId
    recordVersion
    isActive

    # Complex Object Resolvers (2 fields)
    compressedId
    displayName
  }
`;
